import PropTypes from 'prop-types';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { PlatformRow } from './platformRow';
import { useState } from 'react';
import { PLATFORM_STATIC_ICONS } from '../../../../config/icons';
import { useLocales } from '../../../../locales';
import { getDefaultRanges } from '../../../datePicker/utils';
import { overviewCardConfig } from '../../../../config/analytics/analyticsCardsConfig';
import LoadingSpinner from '../../../loadingSpinners/loadingSpinnerWithImage';
import IsLoadingIndicator from '../../../isLoadingIndicator';

import PlaceholderImage from '../../../../assets/images/placeholders/images/placeholder-image-square.jpg';

export function OverviewCard({
  name,
  image,
  platforms,
  platformsInformation,
  data,
  error
}) {
  const { translate: t } = useLocales();
  const imageUrls = Object.keys(platforms)
    .filter((key) => platforms[key])
    ?.map((platform) => PLATFORM_STATIC_ICONS[platform]);

  if (!image) {
    image = PlaceholderImage;
  }

  if (!data || !name || !image || !platforms || !platformsInformation) {
    return (
      <div className="card rounded p-4 container  shadow h-100 justify-content-center align-items-center">
        <IsLoadingIndicator />
      </div>
    );
  }

  return (
    <div className="card rounded p-4 container  shadow h-100">
      <div className="d-flex align-items-center justify-content-between text-align-center">
        <h3 style={{ fontWeight: 500, fontSize: '1.275rem' }}>
          {t('overview')}
        </h3>
        <div className={'d-flex'}>
          <DropDownButton />
          <div className="text-muted">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{t('overviewCard.info_icon')}</Tooltip>}
            >
              <i className="fa-duotone fa-circle-info fa-sm"></i>
            </OverlayTrigger>
          </div>
        </div>
      </div>
      <Row className="jusify-content-between h-100">
        <Col xs={5} className="p-2 d-flex flex-column h-100">
          <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <img
              src={image}
              alt={name}
              className="rounded w-50 center img-thumbnail"
            />
            <p className="text-center fw-bold mt-3 text-truncate mw-100">
              {name}
            </p>
            <div className={'my-2 w-100 text-center text-muted'}>
              {t('connected_platforms')}
            </div>
            <div className={'d-flex flex-wrap'}>
              {imageUrls.map((url) => {
                return (
                  <div className={'h-20px mx-1 rounded-0'} key={url}>
                    <img src={url} alt={name} className="center h-100" />
                  </div>
                );
              })}
            </div>
            {/* <AvatarGroup imageUrls={imageUrls} circle={false} /> */}
          </div>
        </Col>

        <Col xs={7} className="p-2 h-100">
          {data && platforms && platformsInformation ? (
            <div
              style={{
                flexWrap: 'wrap',
                overflow: 'scroll',
                height: '100%',
                maxHeight: '100%'
              }}
            >
              {Object.keys(overviewCardConfig).map((platform) => {
                if (!platformsInformation[platform]) return null;
                // if (!data?.[overviewCardConfig[platform]?.key]) return;

                console.log(data);

                return (
                  <PlatformRow
                    key={platform}
                    platformInfo={platformsInformation[platform][0]}
                    data={data?.[platform]}
                    platform={platform}
                    hasDetails={
                      overviewCardConfig[platform]?.hasDetails || false
                    }
                    dataDelay1Day={
                      overviewCardConfig[platform]?.dataDelay1Day || false
                    }
                  />
                );
              })}
            </div>
          ) : (
            <LoadingSpinner />
          )}
        </Col>
      </Row>
    </div>
  );
}

OverviewCard.propTypes = {
  name: PropTypes.string,
  image: PropTypes.string,
  platforms: PropTypes.any,
  platformsInformation: PropTypes.any,
  data: PropTypes.any,
  error: PropTypes.any
};

const DropDownButton = () => {
  const { translate: t } = useLocales();
  const ranges = getDefaultRanges();
  const [selectedRange, setSelectedRange] = useState(getDefaultRanges()[0]);
  return (
    <div>
      <p className=" m-0 p-0 me-2 fw-bold text-muted">
        {t('analyticsCards.last_30_days')}
      </p>
    </div>
  );

  /*  return (
    <Dropdown className="me-2">
      <Dropdown.Toggle variant="light" id="dropdown-basic" size="sm">
        {t(selectedRange.label)}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {ranges.map((item) => (
          <Dropdown.Item
            key={item.label}
            eventKey={item.label}
            active={item.label === selectedRange.label}
            onClick={() => setSelectedRange(item)}
          >
            {t(item.label)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
  */
};

export default DropDownButton;
